import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export function useDisputesQueue({ status, reason, tier, categoryId, ageHours, search, cursor, limit = 50 }) {
  return useQuery({
    queryKey: ['admin', 'disputes', 'queue', { status, reason, tier, categoryId, ageHours, search, cursor, limit }],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      
      if (status) params.set('status', status);
      if (reason) params.set('reason', reason);
      if (tier) params.set('tier', tier);
      if (categoryId) params.set('categoryId', categoryId);
      if (ageHours) params.set('age_hours', ageHours);
      if (search) params.set('search', search);
      if (cursor) params.set('cursor', cursor);
      params.set('limit', limit);
      
      const { data } = await axios.get(
        `${API_BASE}/api/admin/disputes/queue?${params}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    },
    staleTime: 1 * 60 * 1000, // 1 minute
  });
}
